module.exports = __webpack_public_path__ + "img/a2-s71.0df54143.jpg";